import { useParams, useNavigate } from "react-router-dom";
import "../styles/resultDetails.css";

import gold from "../assets/images/gold medal.png";
import silver from "../assets/images/silver medal.png";
import bronze from "../assets/images/bronze medal.png";

import { useEffect, useState, useCallback } from "react";
import { API_CONFIG } from "../config/api";
import { generateAuthToken, generateURN } from "../components/hmac";

const ResultDetails = () => {
  const { resultID } = useParams();
  const navigate = useNavigate();

  const [resultData, setResultData] = useState({});
  const [tour, setTour] = useState("Tournament");

  const fetchResult = useCallback(async () => {
    try {
      const { host, fetchResultById, basic } = API_CONFIG;
      const urn = generateURN();
      const authToken = generateAuthToken(urn);

      const res = await fetch(
        `https://${host}${fetchResultById.path(resultID)}`,
        {
          method: fetchResultById.method,
          credentials: "include",
          headers: {
            Authorization: `Basic ${basic.BASIC_AUTH_CWUSER}`,
            urn,
            authToken,
          },
        }
      );

      const json = await res.json();
      const data = json?.apiResponseData?.responseData;

      if (data) {
        setResultData(data);
      }
    } catch (error) {
      console.error("API ERROR", error);
    }
  }, [resultID]);

  /* Load result */
  useEffect(() => {
    fetchResult();
  }, [fetchResult]);

  /* Resolve tournament name */
  useEffect(() => {
    if (!resultData?.tournamentID) return;
    // tournament name will remain default unless resolved elsewhere
    setTour("Tournament");
  }, [resultData]);

  return (
    <section className="result-page">
      {/* BACK BUTTON */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {/* PODIUM */}
      {resultData?.players?.length >= 3 && (
        <div className="head">
          <div>
            <h3 id="i2">{resultData.players[1].name}</h3>
            <img src={silver} alt="silver medal" />
          </div>

          <div>
            <h3 id="i1">{resultData.players[0].name}</h3>
            <img src={gold} alt="gold medal" />
          </div>

          <div>
            <h3 id="i3">{resultData.players[2].name}</h3>
            <img src={bronze} alt="bronze medal" />
          </div>
        </div>
      )}

      {/* TITLE */}
      <div className="latest">
        <h1>{tour}</h1>
        <div className="ribbon_2"></div>
      </div>

      {/* RESULT TABLE */}
      {resultData?.players?.length > 0 && (
        <div className="result-table-wrapper">
          <table className="result-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Username</th>
                <th>Rating</th>
                <th>Score</th>
                <th>Performance</th>
              </tr>
            </thead>

            <tbody>
              {resultData.players.map((player, index) => (
                <tr
                  key={index}
                  className={index < 3 ? `top-${index + 1}` : ""}
                >
                  <td>{player.rank}</td>
                  <td className="username-col">{player.name}</td>
                  <td>{player.rating}</td>
                  <td>{player.score}</td>
                  <td>{player.performance}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default ResultDetails;
